export enum AiQuizQuestionsGenerationSource {
  SPEACH_CONTENT = "SPEACH_CONTENT",
  DOCUMENT = "document",
  TEXT_CONTENT = "text",
}
